import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {H2hFactory} from "./h2h-factory";
import {H2hApiService} from "./h2h.api-service";

export class H2hRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, H2hApiService, H2hFactory];
}
